import { render, staticRenderFns } from "./LayerExtraAttributesTable.vue?vue&type=template&id=20f4a323&scoped=true"
import script from "./LayerExtraAttributesTable.vue?vue&type=script&lang=js"
export * from "./LayerExtraAttributesTable.vue?vue&type=script&lang=js"
import style0 from "./LayerExtraAttributesTable.vue?vue&type=style&index=0&id=20f4a323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4a323",
  null
  
)

export default component.exports